/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentLanguageEnum } from './ConversationalAgentLanguageEnum';
import {
  ConversationalAgentLanguageEnumFromJSON,
  ConversationalAgentLanguageEnumFromJSONTyped,
  ConversationalAgentLanguageEnumToJSON,
} from './ConversationalAgentLanguageEnum';
import type { Perturbation } from './Perturbation';
import { PerturbationFromJSON, PerturbationFromJSONTyped, PerturbationToJSON } from './Perturbation';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset
 */
export interface PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset {
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset
   */
  taskType: TaskTypeEnum;
  /**
   *
   * @type {number}
   * @memberof PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset
   */
  hasPredictions?: boolean;
  /**
   *
   * @type {number}
   * @memberof PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset
   */
  originalDataset: number;
  /**
   *
   * @type {Perturbation}
   * @memberof PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset
   */
  readonly perturbation: Perturbation;
  /**
   *
   * @type {number}
   * @memberof PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset
   */
  stateSchema?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset
   */
  evaluateState?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset
   */
  hasState?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset
   */
  hasTokenUsage?: boolean;
  /**
   *
   * @type {ConversationalAgentLanguageEnum}
   * @memberof PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset
   */
  language: ConversationalAgentLanguageEnum;
  /**
   *
   * @type {Array<number>}
   * @memberof PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset
   */
  audioRecordings?: Array<number>;
}

/**
 * Check if a given object implements the PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset interface.
 */
export function instanceOfPerturbedDatasetPolymorphicPerturbedVoiceAgentDataset(
  value: object,
): value is PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset {
  if (!('taskType' in value) || value['taskType'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('originalDataset' in value) || value['originalDataset'] === undefined) return false;
  if (!('perturbation' in value) || value['perturbation'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  return true;
}

export function PerturbedDatasetPolymorphicPerturbedVoiceAgentDatasetFromJSON(
  json: any,
): PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset {
  return PerturbedDatasetPolymorphicPerturbedVoiceAgentDatasetFromJSONTyped(json, false);
}

export function PerturbedDatasetPolymorphicPerturbedVoiceAgentDatasetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset {
  if (json == null) {
    return json;
  }
  return {
    taskType: TaskTypeEnumFromJSON(json['task_type']),
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'] == null ? undefined : json['has_predictions'],
    originalDataset: json['original_dataset'],
    perturbation: PerturbationFromJSON(json['perturbation']),
    stateSchema: json['state_schema'] == null ? undefined : json['state_schema'],
    evaluateState: json['evaluate_state'] == null ? undefined : json['evaluate_state'],
    hasState: json['has_state'] == null ? undefined : json['has_state'],
    hasTokenUsage: json['has_token_usage'] == null ? undefined : json['has_token_usage'],
    language: ConversationalAgentLanguageEnumFromJSON(json['language']),
    audioRecordings: json['audio_recordings'] == null ? undefined : json['audio_recordings'],
  };
}

export function PerturbedDatasetPolymorphicPerturbedVoiceAgentDatasetToJSON(
  value?: Omit<PerturbedDatasetPolymorphicPerturbedVoiceAgentDataset, 'id' | 'perturbation'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    task_type: TaskTypeEnumToJSON(value['taskType']),
    dataset_path: value['datasetPath'],
    has_predictions: value['hasPredictions'],
    original_dataset: value['originalDataset'],
    state_schema: value['stateSchema'],
    evaluate_state: value['evaluateState'],
    has_state: value['hasState'],
    has_token_usage: value['hasTokenUsage'],
    language: ConversationalAgentLanguageEnumToJSON(value['language']),
    audio_recordings: value['audioRecordings'],
  };
}
